import { VideoData, VideoSource } from "@/lib/types";

// Two encodes per breakpoint. These arrays are module-level constants on
// purpose: `useDeferredVideo` takes them as an effect dependency, so a fresh
// array per render would re-run the attach effect on every render.
export const bannerVideoDesktopSources: VideoSource[] = [
  { src: "/hero-desktop.webm", type: "video/webm; codecs=vp9" },
  { src: "/hero-desktop.mp4", type: 'video/mp4; codecs="avc1.4d402a"' },
];

export const bannerVideoMobileSources: VideoSource[] = [
  { src: "/hero-mobile.webm", type: "video/webm; codecs=vp9" },
  { src: "/hero-mobile.mp4", type: 'video/mp4; codecs="avc1.4d401f"' },
];

export const bannerVideo: VideoData = {
  src: "/hero-desktop.webm",
  sources: bannerVideoDesktopSources,
  poster: "/assets/images/octarnal.webp",
  title: "Banner Video",
  isAutoPlay: true,
};
